/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { Button, Title } from '@components/v2/ui';
import { Box, Flex } from '@mantine/core';
import { useStore } from '@store/index';
import { useTranslation } from 'react-i18next';
import classes from './Header.module.css';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */
interface StepperHeaderProps {
	onCancel: () => void;
	onConfirm: () => void;
	title: string;
	isLoading?: boolean;
}

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Header = ({
	onCancel,
	onConfirm,
	title,
	isLoading,
}: StepperHeaderProps) => {
	const { t } = useTranslation();
	const {
		addedProductions,
		productionMethod,
		isAddProductionFromFile,
	} = useStore();

	return (
		<Box className={classes['container-header']}>
			<Flex
				wrap="wrap"
				justify="space-between"
				align="center"
				gap="xs"
			>
				<Flex gap="12px" align="center">
					<Button
						w={160}
						variant="outline"
						type="button"
						onClick={onCancel}
					>
						{t('global.cancel')}
					</Button>
					<Title
						ta="center"
						c="var(--mantine-color-igluPrimary-9)"
						order={6}
					>
						{title}
					</Title>
				</Flex>

				<Flex gap="12px" align="center">
					<Button
						miw={160}
						variant="primary"
						type="button"
						onClick={onConfirm}
						loading={isLoading}
						disabled={
							(productionMethod === 'manual' &&
							addedProductions.length === 0
								? true
								: false) ||
							productionMethod === null ||
							(productionMethod === 'import' &&
							!isAddProductionFromFile
								? true
								: false)
						}
					>
						{t('global.validateAndAddProduction')}
					</Button>
				</Flex>
			</Flex>
		</Box>
	);
};
